import { render, staticRenderFns } from "./ProductoPresentacionesView.vue?vue&type=template&id=605310a2&scoped=true&"
import script from "./ProductoPresentacionesView.vue?vue&type=script&lang=js&"
export * from "./ProductoPresentacionesView.vue?vue&type=script&lang=js&"
import style0 from "./ProductoPresentacionesView.vue?vue&type=style&index=0&id=605310a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605310a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VIcon,VItem,VItemGroup,VRow,VSpacer})
